import React from 'react'
import { RichTextRenderer } from '../../../lib/components'
import { CMSOpportunityDetailsAboutFundType } from '../../../lib/types'
import { CmsSectionText } from './cms-section-text-content'

const CMSAboutFund = ({ aboutFund }: { aboutFund?: CMSOpportunityDetailsAboutFundType }) => {
  if (!aboutFund?.aboutFundText?.length) {
    return null
  }

  return (
    <CmsSectionText dataTestId='cms-about-fund-content'>
      <RichTextRenderer content={aboutFund.aboutFundText} variant='opportunity-details' />
    </CmsSectionText>
  )
}

export { CMSAboutFund }
